import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router } from "react-router-dom";
import store from "./redux";
import theme from "./theme";

// Import & configure dotenv package in development
if (process.env.NODE_ENV === "development") {
	require("dotenv").config();
}

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<Router>
				<ChakraProvider theme={theme}>
					<App />
				</ChakraProvider>
			</Router>
		</Provider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
